import { makeAutoObservable } from 'mobx'
import { type Area } from 'react-easy-crop'

export class CropImageStore {
  private readonly _cropSize: number = 160
  private _imageUrl = ''
  private _file: File | null = null
  private _croppedAreaPixels: Area | null = null

  constructor(cropSize?: number) {
    makeAutoObservable(this)

    if (cropSize) this._cropSize = cropSize
  }

  setFile(file: File) {
    this._file = file
    this._imageUrl = URL.createObjectURL(file)
  }

  setCroppedAreaPixels = (area: Area) => {
    this._croppedAreaPixels = area
  }

  getCroppedBase64Png = async (): Promise<string> => {
    if (!this._imageUrl || !this._croppedAreaPixels) return ''

    const image = await this._loadImage(this._imageUrl)
    const { x, y, width, height } = this._croppedAreaPixels

    const canvas = document.createElement('canvas')
    canvas.width = this._cropSize
    canvas.height = this._cropSize

    const ctx = canvas.getContext('2d')
    if (!ctx) return ''

    ctx.drawImage(image, x, y, width, height, 0, 0, this._cropSize, this._cropSize)

    return canvas.toDataURL('image/png')
  }

  private _loadImage = (url: string): Promise<HTMLImageElement> => {
    return new Promise((resolve, reject) => {
      const img = new Image()
      img.addEventListener('load', () => resolve(img))
      img.addEventListener('error', reject)
      img.setAttribute('crossOrigin', 'anonymous')
      img.src = url
    })
  }

  reset = () => {
    URL.revokeObjectURL(this._imageUrl)
    this._imageUrl = ''
    this._file = null
    this._croppedAreaPixels = null
  }

  get imageUrl() {
    return this._imageUrl
  }

  get file() {
    return this._file
  }

  get cropSize() {
    return this._cropSize
  }
}
